module.exports = __webpack_public_path__ + "img/icon-sort-down-active.7043f3c4.svg";